import React from 'react';

import classNames from 'classnames';

import Ban from '@ast/magma/components/icon/icons/Ban';
import Chart from '@ast/magma/components/icon/icons/Chart';
import CreditCard from '@ast/magma/components/icon/icons/CreditCard';
import EyeSlash from '@ast/magma/components/icon/icons/EyeSlash';
import Loan from '@ast/magma/components/icon/icons/Loan';
import Piggibank from '@ast/magma/components/icon/icons/Piggibank';
import Wallet from '@ast/magma/components/icon/icons/Wallet';

import { BankAccountType } from '@app/queryTyping';

import styles from './AccountCardIcon.pcss';

export const AccountCardIcon : React.FC<{
  readonly className?: string;
  readonly isAccountIconEnabled: boolean,
  readonly isVisible: boolean,
  readonly isClosed: boolean,
  readonly type: BankAccountType
}> = (props) => {
  const {
    className, isAccountIconEnabled, isVisible, isClosed, type,
  } = props;

  if (!isAccountIconEnabled) return <></>;

  if (!isVisible) return <EyeSlash className={classNames(className, styles.icon)} data-stable-name="EyeSlashIcon" />;

  if (isClosed) return <Ban className={classNames(className, styles.icon)} data-stable-name="BanIcon" />;

  if (type === BankAccountType.CHECKING) {
    return (
      <Wallet
        className={classNames(className, styles.icon)}
        data-stable-name="CheckingIcon"
      />
    );
  }

  if (type === BankAccountType.SAVINGS) {
    return (
      <Piggibank
        className={classNames(className, styles.icon)}
        data-stable-name="SavingIcon"
      />
    );
  }

  if (type === BankAccountType.LOAN) {
    return (
      <Loan
        className={classNames(className, styles.icon)}
        data-stable-name="LoanIcon"
      />
    );
  }

  if (type === BankAccountType.CREDITLINE) {
    return (
      <CreditCard
        className={classNames(className, styles.icon)}
        data-stable-name="CreditLineIcon"
      />
    );
  }

  if (type === BankAccountType.INVESTMENT) {
    return (
      <Chart
        className={classNames(className, styles.icon)}
        data-stable-name="InvestmentIcon"
      />
    );
  }

  return <></>;
};
